<template>
  <div class="tw:flex tw:flex-col tw:md:flex-row tw:pt-3 tw:text-sm tw:text-gray-700">
    <div class="tw:flex-col tw:lg:w-1/3">
      <p class="contact-info">{{ address === null ? '' : address }}</p>
      <p class="contact-info">{{ phone === null ? '' : phone }}</p>
    </div>
    <div class="divider tw:hidden tw:md:block tw:mx-4" />
    <div class="tw:flex-col tw:xl:w-1/2 tw:lg:w-auto">
      <p class="contact-info tw:lg:max-w-[150px] tw:xl:max-w-[300px] tw:max-w-full">
        <a class="tw:text-blue-700" rel="noopener noreferrer" target="_blank" :href="websiteUrl">{{ website }}</a>
      </p>
      <p class="contact-info">
        <a class="tw:text-blue-700" rel="noopener noreferrer" target="_blank" :href="mailAddress">{{ email }}</a>
      </p>
    </div>
    <div class="tw:flex tw:flex-col tw:md:items-end tw:items-start tw:w-full tw:mt-2 tw:mb-3 tw:md:my-0">
      <div
        class="tw:flex tw:items-center"
        v-if="propertyId"
        :class="{ 'tw:ml-2': currentAccommodation && currentAccommodation.countryId === 83 }"
      >
        <UiTooltip
          tooltip-position="bottom"
          :label="
            currentAccommodation && currentAccommodation.countryId === 83
              ? $t('tBS_CIN_license_info_text')
              : $t('tBS_alternative_accommodation_ID_tooltip')
          "
        >
          <InformationOutline class="tw:fill-none tw:stroke-gray-700 tw:h-[20px] tw:w-[20px] tw:mr-1" />
        </UiTooltip>
        <p
          :class="{
            'license-number tw:whitespace-nowrap': currentAccommodation && currentAccommodation.countryId !== 83,
          }"
          class="tw:text-sm tw:text-gray-700 tw:md:ml-2"
        >
          {{
            currentAccommodation && currentAccommodation.countryId === 83
              ? $t('tBS_CIN_header')
              : $t('tBS_alternative_accommodation_ID')
          }}:
          {{ propertyId }}
        </p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import InformationOutline from '@/components/icons/InformationOutline.svg?component'
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import { useAccommodationsByOrgId } from '@/layouts/queries'

const store = useStore()
const props = defineProps({
  address: {
    type: String,
    default: '',
  },
  phone: {
    type: String,
    default: '',
  },
  fax: {
    type: String,
    default: '',
  },
  website: {
    type: String,
    default: '',
  },
  email: {
    type: String,
    default: '',
  },
  propertyId: {
    type: String,
    default: '',
  },
})

const selectedOrganisationId = computed(() => store.state?.session?.selectedOrganisation?.id)
const { currentAccommodation } = useAccommodationsByOrgId(selectedOrganisationId)
const mailAddress = computed(() => 'mailto:' + props.email)
const websiteUrl = computed(() =>
  props.website?.startsWith('http://') || props.website?.startsWith('https://')
    ? props.website
    : `https://${props.website}`
)
</script>
<style scoped>
.divider {
  border-right: 1px solid var(--tw-color-gray-300);
  height: 40px;
}
.license-number {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
  @media (max-width: 768px) {
    max-width: 100%;
  }
}
.contact-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: 1024px) {
    max-width: 200px;
  }
  @media (max-width: 768px) {
    max-width: 100%;
  }
}
</style>
